import { useTranslation } from 'react-i18next';

import { MobileBottomNav } from '../Stations/MobileBottomNav';
import { MonobankTokenSection } from '../../../components/features/MonobankTokenSection/MonobankTokenSection';

export const SettingsV2 = () => {
  const { t } = useTranslation();

  const header = (
    <div style={{ marginBottom: '1.25rem' }}>
      <h2 style={{ fontSize: 20, fontWeight: 600, color: '#0f172a', margin: 0 }}>
        {t('dashboard.settings.title')}
      </h2>
      <p style={{ fontSize: 13, color: '#64748b', margin: '4px 0 0' }}>
        {t('dashboard.settings.subtitle')}
      </p>
    </div>
  );

  return (
    <>
      {/* Desktop */}
      <div className="desktop-layout">
        <div style={{ padding: '1.5rem', maxWidth: 720 }}>
          {header}
          <MonobankTokenSection />
        </div>
      </div>

      {/* Mobile */}
      <div className="mobile-layout">
        <header className="mobile-header">
          <div className="mobile-header-top">
            <h1 className="mobile-header-title">
              {t('dashboard.settings.title')}
            </h1>
          </div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>
            {t('dashboard.settings.subtitle')}
          </div>
        </header>

        <main className="mobile-content">
          <MonobankTokenSection />
        </main>

        <MobileBottomNav />
      </div>
    </>
  );
};
